import React from "react";
import { List, Link, Heading, Flex } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useColorModeValue } from "../ui/color-mode";

const FooterNav = ({ heading, items, ...props }) => {
  const hovercolor = useColorModeValue("#008080", "#b3c0f8");

  return (
    <Flex
      // justifyContent={{ base: "left", md: "center" }}
      textAlign={{ base: "center", md: "left" }}
      {...props}
    >
      <List.Root gap={3} w="full" variant="plain">
        <Heading
          as="h6"
          size={{ base: "lg", md: "xs", lg: "md" }}
          pb={{ base: "0", md: "2" }}
          fontWeight="semibold"
        >
          {heading}
        </Heading>
        {items.map((item, index) => (
          <List.Item
            key={index}
            fontSize={{ base: "md", md: "xs", lg: "sm" }}
            justifyContent={{ base: "center", md: "start" }}
          >
            <Link
              color="gray.500"
              fontWeight="semibold"
              as={RouterLink}
              _hover={{
                color: hovercolor,
                textDecoration: "none",
                transform: "scale(1.1)",
                transition: "transform 0.3s ease-in-out",
              }}
              to={item.url}
              target={item.target}
              onClick={() => {
                window.scrollTo({ top: "0", behavior: "auto" });
              }}
              _focus={{ outline: "none" }}
            >
              {item.text}
            </Link>
          </List.Item>
        ))}
      </List.Root>
    </Flex>
  );
};

export default FooterNav;
